import { StateCreator } from 'zustand';

import { DDPNotitie, DDPNotitieTable } from '../types/ddpTypes';

import { NotitieState, NotitieStore } from './types/NotitieStore';
import { PlankDataStore } from './types/PlankDataStore';

const statusToStoreKey = (status: DDPNotitieTable): keyof NotitieState => {
  const statusMap = {
    DEFECTEN: 'werkorderIds',
    CONFLICTEN: 'werklijnIds',
    RESERVES: 'eenheden',
  } as { [key: string]: keyof NotitieState };
  return statusMap[status];
};
const notitieStateCreator: StateCreator<NotitieStore & Partial<PlankDataStore>> = (set, get, __) => ({
  notities: {
    werklijnIds: {},
    werkorderIds: {},
    eenheden: {},
  },
  setNotities: async (notities) => {
    const reducedNotes = notities.reduce(
      (obj, note: DDPNotitie) => {
        if (note.relatedTable === 'DEFECTEN' && note.relatedIdentifier) obj.werkorderIds[note.relatedIdentifier] = note;
        if (note.relatedTable === 'CONFLICTEN' && note.relatedIdentifier)
          obj.werklijnIds[note.relatedIdentifier] = note;
        if (note.relatedTable === 'RESERVES' && note.relatedIdentifier) obj.eenheden[note.relatedIdentifier] = note;
        return obj;
      },
      {
        werklijnIds: {},
        werkorderIds: {},
        eenheden: {},
      },
    );
    set((state) => ({
      notities: {
        ...state.notities,
        werklijnIds: { ...reducedNotes.werklijnIds },
        werkorderIds: { ...reducedNotes.werkorderIds },
        eenheden: { ...reducedNotes.eenheden },
      },
    }));
  },
  setNotitie: async (notitie) => {
    if (!notitie.relatedTable || !notitie.relatedIdentifier) return;
    const storeKey = statusToStoreKey(notitie.relatedTable);
    set((state) => ({
      notities: {
        ...state.notities,
        [storeKey]: { ...state.notities[storeKey], [String(notitie.relatedIdentifier)]: { ...notitie } },
      },
    }));
  },
  getDefectNotitie: (defect) => {
    const notitie =
      defect.werkorderId !== null
        ? get().notities.werkorderIds?.[String(defect.werkorderId)]
        : get().notities.eenheden?.[defect.eenheidNummer];

    if (notitie?.relatedTable !== 'DEFECTEN') return;
    return notitie;
  },
  getConflictNotitie: (conflict) => {
    const notitie = get().notities.werklijnIds?.[conflict.werklijnId];
    if (notitie?.relatedTable !== 'CONFLICTEN') return;
    return notitie;
  },
  getReserveNotitie: (reserve) => {
    const notitie = get().notities.eenheden?.[String(reserve.eenheid)];
    if (notitie?.relatedTable !== 'RESERVES') return;
    return notitie;
  },
});
export default notitieStateCreator;
